import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class OnboardingConnectSourceTour extends TourBase {
	get id(): string {
		return TourId.ONBOARDING_CONNECT_SOURCE;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: () => {
					return $('#page-onboarding .template-sources-list li').eq(0);
				},
			},
		];
	}
}
